import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Login from '@/views/Login/Login.vue'
import layout from '@/views/Main.vue'
import home from '@/views/components/home.vue'
import NotFound from '@/views/404/NotFound.vue'; // 👈 新增 404 组件
const router = new VueRouter({
  mode: 'history',
  routes: [{
      path: '/',
      name: '',
      redirect: '/login',
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/homeOne',
      name: 'homeOne',
      component: () => import("../views/components/homeOne.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/homeOneLawMore',
      name: 'homeOneLawMore',
      component: () => import("../views/components/homeOneLawMore.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/homeOneLaw',
      name: 'homeOneLaw',
      component: () => import("../views/components/homeOneLaw.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/LoginHome',
      name: 'LoginHome',
      component: () => import("../views/Login/LoginHome.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/YHZGTotal',
      name: '隐患排查清单',
      component: () => import("../views/EnterPriseRanking/YHZGTotal.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/YHZLTotal',
      name: '隐患治理清单1',
      component: () => import("../views/EnterPriseRanking/YHZLTotal.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/TotalEducationDetail',
      name: '报表详情',
      component: () => import("../views/EducationTraining/TotalEducationDetail.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/OKBook',
      name: '结业证书报表',
      component: () => import("../views/EducationTraining/OKBook.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/UpMeetingQY',
      name: '企业安全例会',
      component: () => import("../views/regularMeeting/UpMeetingQY.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: '布局',
      component: layout,
      children: [{
          path: 'home',
          name: '首页',
          component: () => import("../views/components/home.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'Module',
          name: '菜单管理',
          component: () => import("../views/System/Module.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'bookMan',
          name: '课件目录大纲',
          component: () => import("../views/System/bookMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'EqMannage',
          name: '设备类别',
          component: () => import("../views/System/EqMannage.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'Role',
          name: '角色管理',
          component: () => import("../views/System/Role.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'dept',
          name: '行业管理',
          component: () => import("../views/System/dept.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'user',
          name: '用户管理',
          component: () => import("../views/System/user.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'region',
          name: '部门管理',
          component: () => import("../views/System/region.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'Post',
          name: '岗位管理',
          component: () => import("../views/System/Post.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'People',
          name: '员工角色权限',
          component: () => import("../views/System/People.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'Law',
          name: '法律法规',
          component: () => import("../views/System/Law.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeInfo',
          name: '企业基本信息维护',
          component: () => import("../views/safeMannage/safeInfo.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeInfoMan',
          name: '企业信息管理',
          component: () => import("../views/safeMannage/safeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeInfoPel',
          name: '从业人员档案信息',
          component: () => import("../views/safeMannage/safeInfoPel.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeInfoManPel',
          name: '安全机构员工管理',
          component: () => import("../views/safeMannage/safeInfoManPel.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeInfoCar',
          name: '车辆档案录入',
          component: () => import("../views/safeMannage/safeInfoCar.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarMaintenance',
          name: '车辆维护记录',
          component: () => import("../views/safeMannage/CarMannage/CarMaintenance.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarYearCheck',
          name: '车辆年检记录',
          component: () => import("../views/safeMannage/CarMannage/CarYearCheck.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CartechnologyRecond',
          name: '技术等级评定记录',
          component: () => import("../views/safeMannage/CarMannage/CartechnologyRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarStyleRecond',
          name: '车辆类型等级评定',
          component: () => import("../views/safeMannage/CarMannage/CarStyleRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarCheckRecond',
          name: '车辆检测记录',
          component: () => import("../views/safeMannage/CarMannage/CarCheckRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarChangeRecond',
          name: '车辆维修记录',
          component: () => import("../views/safeMannage/CarMannage/CarChangeRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'EQMannages',
          name: '维修设备管理',
          component: () => import("../views/safeMannage/EQMannages.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarDriveRecond',
          name: '车辆行驶里程记录',
          component: () => import("../views/safeMannage/CarMannage/CarDriveRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarAfterRecond',
          name: '车辆变更记录',
          component: () => import("../views/safeMannage/CarMannage/CarAfterRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarComponentsRecond',
          name: '部件更换记录',
          component: () => import("../views/safeMannage/CarMannage/CarComponentsRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarAccidentRecond',
          name: '车辆事故记录',
          component: () => import("../views/safeMannage/CarMannage/CarAccidentRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarMaintenanceRecond',
          name: '车辆维护计划',
          component: () => import("../views/safeMannage/CarMannage/CarMaintenanceRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CardeviceMan',
          name: '车辆设备管理',
          component: () => import("../views/safeMannage/CarMannage/CardeviceMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CardeviceTotal',
          name: '车辆设备台账',
          component: () => import("../views/safeMannage/CarMannage/CardeviceTotal.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'leaderC',
          name: '任务开关',
          component: () => import("../views/DoubleDefense/DoubleAnalysis/leaderC.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarChange',
          name: '汽车设备维修管理',
          component: () => import("../views/safeMannage/CarChange.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DoubleAnalysis',
          name: '风险分析单元',
          component: () => import("../views/DoubleDefense/DoubleAnalysis/DoubleAnalysis.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DoubleIdentify',
          name: '风险辨识评级',
          component: () => import("../views/DoubleDefense/DoubleAnalysis/DoubleIdentify.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DoubleGrade',
          name: '风险分级管控',
          component: () => import("../views/DoubleDefense/DoubleAnalysis/DoubleGrade.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DoubleFourColor',
          name: '风险公示图',
          component: () => import("../views/DoubleDefense/DoubleAnalysis/DoubleFourColor.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DoubleTotle',
          name: '风险点清单',
          component: () => import("../views/DoubleDefense/DoubleAnalysis/DoubleTotle.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DangerInspect',
          name: '隐患排查表',
          component: () => import("../views/DoubleDefense/DangerInspect/DangerInspect.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DangeRecord',
          name: '隐患排查记录',
          component: () => import("../views/DoubleDefense/DangerInspect/DangeRecord.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DangerOperate',
          name: '隐患登记',
          component: () => import("../views/DoubleDefense/DangerOperate/DangerOperate.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DangeToExamine',
          name: '隐患定级',
          component: () => import("../views/DoubleDefense/DangerOperate/DangeToExamine.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DangeChangeLoad',
          name: '隐患待整改',
          component: () => import("../views/DoubleDefense/DangerOperate/DangeChangeLoad.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DangeChange',
          name: '隐患整改',
          component: () => import("../views/DoubleDefense/DangerOperate/DangeChange.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DangeReview',
          name: '隐患复查',
          component: () => import("../views/DoubleDefense/DangerOperate/DangeReview.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DangeToExamineList',
          name: '隐患治理清单',
          component: () => import("../views/DoubleDefense/DangerOperate/DangeToExamineList.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeFreePlan',
          name: '年度投入计划',
          component: () => import("../views/safetyManagement/safeFreePlan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeFreeUserPlan',
          name: '提取计划',
          component: () => import("../views/safetyManagement/safeFreeUserPlan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeFreeUserTotal',
          name: '使用台账',
          component: () => import("../views/safetyManagement/safeFreeUserTotal.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'MannageWay',
          name: '制度管理',
          component: () => import("../views/safetyManagement/MannageWay.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'JSYRecond',
          name: '驾驶员奖惩记录',
          component: () => import("../views/safetyManagement/JSYRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CLRecond',
          name: '车辆奖惩记录',
          component: () => import("../views/safetyManagement/CLRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'QPRecond',
          name: '强凭记录',
          component: () => import("../views/safetyManagement/QPRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeFreeList',
          name: '经费投入清单',
          component: () => import("../views/safetyManagement/safeFreeList.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeFreeGive',
          name: '资金划拨管理',
          component: () => import("../views/safetyManagement/safeFreeGive.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeFreeTo',
          name: '费用支出管理',
          component: () => import("../views/safetyManagement/safeFreeTo.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeRanking',
          name: '完成率排名统计',
          component: () => import("../views/safetyManagement/safeRanking.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'InfoNotice',
          name: '消息通知',
          component: () => import("../views/safetyManagement/InfoNotice.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'UpRelese',
          name: '下发任务',
          component: () => import("../views/safetyManagement/UpRelese.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'NoticeDowmEnterQY',
          name: '消息通知下发',
          component: () => import("../views/safetyManagement/NoticeDowmEnterQY.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'NoticeDowmEnterQYBoss',
          name: '上级消息通知',
          component: () => import("../views/safetyManagement/NoticeDowmEnterQYBoss.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'NoticeDowm',
          name: '文件公示',
          component: () => import("../views/safetyManagement/NoticeDowm.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'downBack',
          name: '任务管理',
          component: () => import("../views/safetyManagement/downBack.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'systemMan',
          name: '制度管理',
          component: () => import("../views/safetyManagement/systemMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'Organization',
          name: '应急组织',
          component: () => import("../views/contingencyManage/Organization.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'rescueEquipment',
          name: '应急装备',
          component: () => import("../views/contingencyManage/rescueEquipment.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'review',
          name: '应急预案',
          component: () => import("../views/contingencyManage/review.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'FilingStatus',
          name: '备案状态',
          component: () => import("../views/contingencyManage/FilingStatus.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'evaluationInput',
          name: '应急演练评估',
          component: () => import("../views/contingencyManage/evaluationInput.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'PlanTraining',
          name: '应急预案培训',
          component: () => import("../views/contingencyManage/PlanTraining.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'contingencyPlan',
          name: '应急演练计划',
          component: () => import("../views/contingencyManage/contingencyPlan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'contingencyRecond',
          name: '应急演练记录',
          component: () => import("../views/contingencyManage/contingencyRecond.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'PlanReviewReport',
          name: '应急预案定期评审记录',
          component: () => import("../views/contingencyManage/PlanReviewReport.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'UpMeeting',
          name: '安全例会',
          component: () => import("../views/regularMeeting/UpMeeting.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'minMeeting',
          name: '安全学习会议记录',
          component: () => import("../views/regularMeeting/minMeeting.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'attendanceBook',
          name: '签到簿',
          component: () => import("../views/regularMeeting/attendanceBook.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'createTask',
          name: '创建任务派发',
          component: () => import("../views/standardization/createTask.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'createTaskNeed',
          name: '按要素创建',
          component: () => import("../views/standardization/createTaskNeed.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'createTaskMy',
          name: '我的任务',
          component: () => import("../views/standardization/createTaskMy.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'riskRanking',
          name: '风险辨识统计',
          component: () => import("../views/AssessmentRanking/riskRanking.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'dangerRanking',
          name: '隐患治理统计',
          component: () => import("../views/AssessmentRanking/dangerRanking.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'safeOkRanking',
          name: '安全经费完成率统计',
          component: () => import("../views/AssessmentRanking/safeOkRanking.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'SystemExamine',
          name: '审批流程配置',
          component: () => import("../views/safeMannageAll/SystemExamine.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'SystemNumber',
          name: '菜单名称分值',
          component: () => import("../views/safeMannageAll/SystemNumber.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'hgxMenu',
          name: '合规性检查清单',
          component: () => import("../views/safeMannageAll/hgxMenu.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'SelfZCZJ',
          name: '自查自纠预警',
          component: () => import("../views/safeMannageAll/SelfZCZJ.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'QYSafeInfoMan',
          name: '企业信息档案',
          component: () => import("../views/EnterPriseSafeInfo/QYSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'AQJFSafeInfoMan',
          name: '企业安全经费',
          component: () => import("../views/EnterPriseSafeInfo/AQJFSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarChangeSafeInfoMan',
          name: '维修设备档案',
          component: () => import("../views/EnterPriseSafeInfo/CarChangeSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarSafeInfoMan',
          name: '车辆档案',
          component: () => import("../views/EnterPriseSafeInfo/CarSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'GLZDSafeInfoMan',
          name: '企业管理制度',
          component: () => import("../views/EnterPriseSafeInfo/GLZDSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'MeetSafeInfoMan',
          name: '企业安全例会',
          component: () => import("../views/EnterPriseSafeInfo/MeetSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'PeoplePXSafeInfoMan',
          name: '人员培训记录',
          component: () => import("../views/EnterPriseSafeInfo/PeoplePXSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'PeopleSafeInfoMan',
          name: '人员档案',
          component: () => import("../views/EnterPriseSafeInfo/PeopleSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: 'YJYLSafeInfoMan',
        //   name: '企业应急演练',
        //   component: () => import("../views/EnterPriseSafeInfo/YJYLSafeInfoMan.vue")
        // },
        {
          path: 'UpReleseEnter',
          name: '任务整改下发',
          component: () => import("../views/EnterPriseNotice/UpReleseEnter.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'NoticeDowmEnter',
          name: '通知下发',
          component: () => import("../views/EnterPriseNotice/NoticeDowmEnter.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'QYNoticeDowmEnter',
          name: '消息通知下发',
          component: () => import("../views/EnterPriseNotice/QYNoticeDowmEnter.vue"),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: 'GongShiTu',
        //   name: '企业风险公示查询',
        //   component: () => import("../views/EnterPriseDouble/GongShiTu.vue")
        // },
        {
          path: 'GuanKongTotal',
          name: '风险管控清单',
          component: () => import("../views/EnterPriseDouble/GuanKongTotal.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'YHPCTotal',
          name: '隐患排查治理清单',
          component: () => import("../views/EnterPriseDouble/YHPCTotal.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'FXBS',
          name: '风险点清单统计',
          component: () => import("../views/EnterPriseRanking/FXBS.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'YHZG',
          name: '隐患排查清单统计',
          component: () => import("../views/EnterPriseRanking/YHZG.vue"),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: 'YHZL',
          name: '隐患治理清单统计',
          component: () => import("../views/EnterPriseRanking/YHZL.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'AQJF',
          name: '企业安全经费统计',
          component: () => import("../views/EnterPriseRanking/AQJF.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'YJYLSafeInfoMan',
          name: '企业应急演练统计',
          component: () => import("../views/EnterPriseSafeInfo/YJYLSafeInfoMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'GongShiTu',
          name: '企业风险公示统计',
          component: () => import("../views/EnterPriseDouble/GongShiTu.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'DTJK',
          name: '动态监控上传排名',
          component: () => import("../views/EnterPriseRanking/DTJK.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'YJPX',
          name: '企业教育培训统计',
          component: () => import("../views/EnterPriseRanking/YJPX.vue"),
          meta: {
            requiresAuth: true
          }
        },
        // {
        //   path: 'YJPX',
        //   name: '车辆资质证件',
        //   component: () => import("../views/EnterPriseRanking/YJPX.vue"),
        //   meta: {
        //     requiresAuth: true
        //   }
        // },
        {
          path: 'Day',
          name: '日报表',
          component: () => import("../views/EnterPriseMoniter/Day.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'Moute',
          name: '月报表',
          component: () => import("../views/EnterPriseMoniter/Moute.vue"),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: 'week',
          name: '周报表',
          component: () => import("../views/EnterPriseMoniter/week.vue"),
          meta: {
            requiresAuth: true
          }
        },

        {
          path: 'CarMoniter',
          name: '车辆动态监控',
          component: () => import("../views/EnterPriseMoniter/CarMoniter.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'publicBook',
          name: '公共课件',
          component: () => import("../views/classBook/publicBook.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'MyBook',
          name: '我的课件',
          component: () => import("../views/classBook/MyBook.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'YearEducation',
          name: '年度培训计划',
          component: () => import("../views/EducationTraining/YearEducation.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'SelfYearEducation',
          name: '自主设定教学计划',
          component: () => import("../views/EducationTraining/SelfYearEducation.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'PlanEducation',
          name: '培训学习任务',
          component: () => import("../views/EducationTraining/PlanEducation.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'TotalEducation',
          name: '学习统计报表',
          component: () => import("../views/EducationTraining/TotalEducation.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'ThreeEducation',
          name: '岗前三级培训',
          component: () => import("../views/EducationTraining/ThreeEducation.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'TwoEducation',
          name: '两类人员培训',
          component: () => import("../views/EducationTraining/TwoEducation.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'MannageTest',
          name: '企业考试',
          component: () => import("../views/EducationTraining/MannageTest.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'QuestionMan',
          name: '题库管理',
          component: () => import("../views/EducationTraining/QuestionMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'RegionMan',
          name: '双盲部门管理',
          component: () => import("../views/RoundMannage/RegionMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'PoliceMan',
          name: '执法人员管理',
          component: () => import("../views/RoundMannage/PoliceMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'planMan',
          name: '双随机计划',
          component: () => import("../views/RoundMannage/planMan.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: 'CarLog',
          name: '行车日志',
          component: () => import("../views/safetyManagement/CarLog.vue"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: '*',
          name: 'NotFound',
          component: () => import("../views/404/NotFound.vue"),
          meta: {
            requiresAuth: false
          } // 404 页面无需登录
        }
      ]

    }
  ]
})


// 🛡️ 导航守卫（登录拦截）
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token'); // 获取 token

//   // 判断目标路由是否需要认证
//   const requiresAuth = to.matched.some(record => record.meta && record.meta.requiresAuth);

//   if (requiresAuth && !token) {
//     // 需要登录但未登录 → 跳转登录页
//     next({
//       path: '/login',
//       query: { redirect: to.fullPath }
//     });
//   } else {
//     // 否则放行
//     next();
//   }
// });
// 🛡️ 全局前置守卫
// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token');

//   // 1. 如果目标是登录页，直接放行（避免死循环）
//   if (to.path === '/login') {
//     next();
//     return;
//   }

//   // 2. 判断目标路由是否需要认证
//   const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

//   if (requiresAuth) {
//     if (token) {
//       // 3. 需要认证且有 Token -> 放行
//       next();
//     } else {
//       // 4. 需要认证但无 Token -> 携带参数跳转登录
//       // ElementUI 友好提示（可选）
//       // Message.warning('请先登录');
//       next({
//         path: '/login',
//         query: {
//           redirect: to.fullPath
//         } // 保存目标路径
//       });
//     }
//   } else {
//     // 5. 不需要认证的页面（如 404, Login）直接放行
//     next();
//   }
// });



router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const loginTime = localStorage.getItem('loginTime');
  const sessionActive = sessionStorage.getItem('session_active');
  const EXPIRY_24H = 24 * 60 * 60 * 1000;

  // 检查 24 小时是否过期
  const isExpired = loginTime && (Date.now() - parseInt(loginTime)) > EXPIRY_24H;
  // 检查是否新开浏览器（sessionStorage 中没有 session_active）
  const isNewSession = !sessionActive;

  if (isExpired || isNewSession) {
    localStorage.removeItem('token');
    localStorage.removeItem('loginTime');
    sessionStorage.removeItem('session_active');
  }

  const validToken = token && !isExpired && !isNewSession;

  if (to.path === '/login') {
    if (validToken) {
      next({ path: '/home' });
    } else {
      next();
    }
  } else {
    if (validToken) {
      next();
    } else {
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  }
});





export default router



// WEBPACK FOOTER //
// ./src/router/index.js